import Storage from "./Storage";

export const checkContainProhibitedItem = (itemName, listProhibited) => {
    let prohibiteds = [];
    if (!itemName) {
        return prohibiteds
    }
    for (let key in listProhibited) {
        let itemNames = itemName.toLowerCase();
        let item = listProhibited[key];
        let keywords = item.ProhibitedKeyword.split(' ');
        let keyword = item.ProhibitedKeyword.toLowerCase();
        // if (keyword === 'black pepper') {
        //     console.log(itemNames)
        // }
        if (keywords.length >= 2) {
            // if (keyword === 'black pepper') {
            //     console.log(1)
            // }
            
            if (itemNames.indexOf(`${keyword.replace(/\s+/gmi, '')}`) !== -1) {
                // if (keyword === 'black pepper') {
                //     console.log(2)
                // }
                prohibiteds.push(item.ProhibitedKeyword)
            } else {
                // if (keyword === 'black pepper') {
                //     console.log(3)
                // }
                itemNames = itemNames.replace(/([^a-zA-Z0-9']|_)+/gmi, " ") 
                if (itemNames.indexOf(keyword) !== -1) {
                    // if (keyword === 'black pepper') {
                    //     console.log(4)
                    // }
                    prohibiteds.push(item.ProhibitedKeyword)
                }
            }
        } else {
            // if (keyword === 'black pepper') {
            //     console.log(5)
            // }
            if (itemNames.indexOf(keyword) !== -1) {
                // if (keyword === 'black pepper') {
                //     console.log(6)
                // }
                prohibiteds.push(item.ProhibitedKeyword)
            }
        }
    }
    return prohibiteds;
}

export const getKeyCookieOfUserCurrent = (key) => {
    let userNameCurrent = Storage.get('user') ? Storage.get('user').user_name : '';
    return `${key}_${userNameCurrent}`
}


// WEBPACK FOOTER //
// ./src/services/prohibitedHelper.js